<template>
  <el-dialog
    title="批量打印"
    :visible.sync="dialogFormVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog">
    <div ref="print1" >
    <div v-for="(item,index) in tabledata">
    <CstagreementMachiningPrint ref="CstagreementMachiningPrint" :batchprint="true" :issimple="true" ></CstagreementMachiningPrint>
    <P style='page-break-after:always'>&nbsp;</P>
    </div>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="info" @click="print1">打印</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import CstagreementMachiningPrint from './CstagreementMachiningPrint';
  import {save} from '@/api/order/printlog';

    export default {
      name: "CstagreementBatchPrint",
      data() {
        return {
          tabledata:[],
          dialogFormVisible: false,
        }
      },
      props: {
        printbaibao: {
          default: false
        },
      },
      methods: {
        show(unitguids) {
          this.tabledata = [];
          var ug=unitguids.split(';');
          for (var s in ug) {
            if (!ug[s]) continue;
            this.tabledata.push({unitguid: ug[s]});
          }
          this.dialogFormVisible = true;
          this.$nextTick(() => {
            for (let i in this.tabledata) {
              this.$refs.CstagreementMachiningPrint[i].initData({unitguid: this.tabledata[i].unitguid});
              this.$refs.CstagreementMachiningPrint[i].show('');
            }
          })
        },
        print1() {
          if(this.tabledata.length==0)
            return;

          this.$print(this.$refs.print1);
          // var erps='';
          // for(let i in this.tabledata){
          //   erps+=this.tabledata[i].erpserial+';';
          // }
          //
          // save({erpserial: erps, invoicesource: this.tabledata[0].invoicesource}).then(response => {
          //   if (response.data.code == 0) {
          //     this.dialogFormVisible = false;
          //     this.$emit("bindGrid");//未打印过，刷新父页面
          //   }
          // })
        },
      },
      components: {
        CstagreementMachiningPrint,
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/MachiningBatchPrint.vue